'use client';

import { useTranslations } from 'next-intl';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import { getYoutubeIdFromUrl } from '~/utils/utils';

export const VideoInsert = ({ url, title }: { url: string; title: string }) => {
  const t = useTranslations('GLOBAL');

  return (
    <div className="interaction-aside__video" data-testid="main-video">
      <LiteYouTubeEmbed
        id={getYoutubeIdFromUrl(url)}
        title={title}
        announce={t('VIDEO_TITLE')}
      />
    </div>
  );
};
